<script lang="ts">
  /**
   * Settings' "About": what this is and what it is made of. A page of its own
   * laid over Settings (the shell's `FullPage`, chevron dress), for the same
   * reason `ControlsPage.svelte` is one: Back steps out of it and leaves
   * Settings open (`docs/decisions/0047`). The build it is sits at the foot of
   * Settings itself (`Settings.svelte`).
   *
   * It opens on Interlock's mark and name, drawn as the menu frame draws them:
   * the shell's `GameMark` (game-shell 1.6.0, the part the frame draws its own
   * tile with) at the sidebar's size, decorative because the name is written
   * right under it, and the name at the display step. The full-page screens
   * carry no frame, so the page draws its own (`docs/decisions/0057` copied the
   * tile here; `docs/decisions/0058` replaced the copy with the part).
   */
  import { FullPage, GameMark } from '@artibens/app-shell';

  import InterlockMark from '../glyphs/InterlockMark.svelte';
  import { INTERLOCK_SIGNATURE } from '../theme/accent.js';

  const { open, onclose }: { open: boolean; onclose: () => void } = $props();
</script>

{#snippet mark()}<InterlockMark />{/snippet}

<!-- `wide`, as Settings under it is (and `ControlsPage`): from 1024px a page
     narrower than the one it is laid over lets that one show at its sides. -->
<FullPage {open} title="About" dress="chevron" wide {onclose} testid="about-sheet">
  <div class="about">
    <GameMark name={INTERLOCK_SIGNATURE.name} {mark} size="lg" decorative testid="about-mark" />
    <p class="about-name" data-testid="about-name">{INTERLOCK_SIGNATURE.name}</p>
    <p class="about-tagline">A block-stacking game, alone or together</p>
    <p class="about-description">
      Sprint, Survival and a daily run on your own; duels, curses, tug and co-op with somebody else.
      Solo play works fully offline once it is installed.
    </p>
    <p class="about-credit">Music and art are original, made for this game.</p>
  </div>
</FullPage>

<style>
  .about {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--ui-space-2);
    text-align: center;
    padding: var(--ui-space-5) var(--ui-space-2);
  }

  .about-name {
    margin: 0;
    font: var(--ui-text-display);
    letter-spacing: -0.01em;
  }

  .about-tagline {
    margin: 0;
    font: var(--ui-text-heading);
    color: var(--ui-accent);
  }

  .about-description {
    margin: var(--ui-space-3) 0 0;
    max-width: 26rem;
    font: var(--ui-text-body);
    line-height: 1.5;
    color: var(--ui-ink-2);
  }

  .about-credit {
    margin: var(--ui-space-4) 0 0;
    font: var(--ui-text-label);
    color: var(--ui-ink);
  }
</style>
